import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-checkout-confirm',
  templateUrl: './product-checkout-confirm.component.html',
  styleUrls: ['./product-checkout-confirm.component.scss']
})
export class ProductCheckoutConfirmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
